export default {
  userAllInfo(state) {
    return state.userAllInfo;
  },
  dictTree(state) {
    return state.dictTree;
  },
  shoppingCart(state) {
    return state.shoppingCart;
  },
  invoiceList(state) {
    return state.invoiceList;
  },
  invoiceMoney(state) {
    return state.invoiceMoney;
  },
  selectProduct(state) {
    return state.selectProduct;
  }
}